import { MapfreButtonComponent } from '../../individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../section-components/mapfre-modal/mapfre-modal.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { Language } from "../../../app.language";
import { ModalOptions } from "../../../_models/modal-options";
import { MapfreDesignLibraryComponent } from "./../../../mapfre-design-library.component";
import { AcmicService } from "../../../_services/acmic.service";
import { FooterPositionService } from "@services/footer-position-service/footer-position.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbRippleModule, MapfreModalComponent, MapfreButtonComponent],
  selector: "mapfre-footer",
  templateUrl: "./footer.component.html"
})
export class FooterComponent extends MapfreDesignLibraryComponent
  implements OnInit {
  @Input() hideMe = false;
  @Input() state = false;
  defaultLanguage: string;
  footerHelpModalOptions: ModalOptions;
  hideModal = false;
  year: number;
  stateCode: string;
  isFooterFixed:boolean;

  constructor(
    public translate: TranslateService,
    public _languages: Language,
    private acmicService: AcmicService,
    private footerPositon:FooterPositionService
  ) {
    super(translate, _languages);
    this.footerHelpModalOptions = new ModalOptions({
      additionalButtonClasses: "footer-flat",
      additionalClasses: "modal-dialog center-on-page modal-small",
      animatePosition: "bottom",
      buttonCopy: "FOOTER_DEFAULT_LANGUAGE",
      headerIconClass: "language",
      howManyIconsUsed: 2,
      iconClasses: "language, unfold_more",
      iconFamily: "material-icons",
      modalId: "langModal",
      modalTranslateCopy: "MODAL_USER_LANGUAGE_TITLE",
      screenReader: false,
      showIcons: true,
      typeOfModal: "footer"
    });
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }
  switchUserLanguage(): void {
    // set user default language into local storage
    localStorage.setItem("defaultUserLanguage", this.defaultLanguage);
    this.setLang(this.defaultLanguage);
  }
  ngOnInit() {
    this.stateCode = this.acmicService.isACMIC() ? "ACMIC" : "MA";
    this.year = new Date().getFullYear();
    this.defaultLanguage = localStorage.getItem("defaultUserLanguage") || "EN";
    this.switchUserLanguage();
    this.footerPositon.$dropdownOpenState.subscribe((state)=>{
        this.isFooterFixed=state
    })
  }
}
